import { render, staticRenderFns } from "./Ranking.vue?vue&type=template&id=2305fb38&scoped=true&"
import script from "./Ranking.vue?vue&type=script&lang=ts&"
export * from "./Ranking.vue?vue&type=script&lang=ts&"
import style0 from "./Ranking.vue?vue&type=style&index=0&id=2305fb38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2305fb38",
  null
  
)

export default component.exports